<!--label>{{getShopUrl()}}</!--label-->
<div *ngIf="siteData" class="iframe-container justify-content-center" [class.is-expanded]="isExpanded">
  <div class="iframe-wrapper" [ngClass]="ifView">
    <iframe *ngIf="siteData && previewToken" [ngClass]="ifView" class="iframe-style" [frameBorder]="0"
      [src]="getShopUrl() | safeUrl"></iframe>
  </div>
</div>